import { render } from "./SogFlexColumn.vue?vue&type=template&id=e05a65c8&scoped=true"
const script = {}

import "./SogFlexColumn.vue?vue&type=style&index=0&id=e05a65c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e05a65c8"]])

export default __exports__